import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HvlBaseModel } from '@hvlng/framework-bff/core/src/model/hvl-base-model';

@Component({
    selector: 'hr-master-data-record-history',
    templateUrl: './hr-master-data-record-history.component.html',
})
export class HrMasterDataRecordHistoryComponent implements OnInit {
    model : HvlBaseModel;
    listData :HvlBaseModel[] = [];

    constructor(
        public config: DynamicDialogConfig
    ) {}

    ngOnInit(): void {
        this.model = this.config.data;
        this.listData.push(this.model);
    }

}
